import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define interfaces for the state structure
interface BookmarkModel {
  [key: string]: any;
}

interface ViewBookmarkState {
  visible: boolean;
  model: BookmarkModel;
}

interface CreateBookmarkState {
  visible: boolean;
}

interface EditBookmarkState {
  visible: boolean;
  model: BookmarkModel;
}

interface BookmarkModalState {
  visible: boolean;
  viewBookmark: ViewBookmarkState;
  createBookmark: CreateBookmarkState;
  editBookmark: EditBookmarkState;
}

const initialState: BookmarkModalState = {
  visible: false,
  viewBookmark: {
    visible: false,
    model: {}
  },
  createBookmark: {
    visible: false
  },
  editBookmark: {
    visible: false,
    model: {}
  }
};

export const bookmarkModalSlice = createSlice({
  name: 'bookmarkModal',
  initialState,
  reducers: {
    // Main modal actions
    showModal: (state) => {
      state.visible = true;
    },
    closeModal: () => initialState,
    
    // View bookmark actions
    showViewBookmark: (state) => {
      state.viewBookmark.visible = true;
    },
    loadViewBookmark: (state, action: PayloadAction<BookmarkModel>) => {
      state.viewBookmark.model = action.payload;
    },
    closeViewBookmark: (state) => {
      state.viewBookmark.visible = false;
      state.viewBookmark.model = {};
    },
    
    // Create bookmark actions
    showCreateBookmark: (state) => {
      state.createBookmark.visible = true;
    },
    closeCreateBookmark: (state) => {
      state.createBookmark.visible = false;
    },
    
    // Edit bookmark actions
    showEditBookmark: (state) => {
      state.editBookmark.visible = true;
    },
    loadEditBookmark: (state, action: PayloadAction<BookmarkModel>) => {
      state.editBookmark.model = action.payload;
    },
    closeEditBookmark: (state) => {
      state.editBookmark.visible = false;
      state.editBookmark.model = {};
    }
  }
});

export const {
  showModal,
  closeModal,
  showViewBookmark,
  loadViewBookmark,
  closeViewBookmark,
  showCreateBookmark,
  closeCreateBookmark,
  showEditBookmark,
  loadEditBookmark,
  closeEditBookmark
} = bookmarkModalSlice.actions;

export default bookmarkModalSlice.reducer;
